import React, { useState, useEffect } from "react";
import LayoutProvider from "../../../../providers/LayoutProvider";
import "./style.scss";
import StepSelectFlight from "../../../../components/Training/RequestSignature/StepSelectFlight";
import StepTwo from "../../../../components/Training/RequestSignature/StepTwo";
import StepThree from "../../../../components/Training/RequestSignature/StepThree";
import StepFour from "../../../../components/Training/RequestSignature/StepFour";
import StepZero from "../../../../components/Training/RequestSignature/StepZero";
import { useAppDispatch, useAppSelector } from "../../../../hooks/app";
import { getInstructors, getInstructorsFromApi, getUserApiStatus, setInstructorsList, setStatusForStudentInstructor, setStudentsList } from "../../../../store/slices/instructor-student.slice";
import { API_STATUS, REQUEST_TYPES } from "../../../../constants";
import SpinnerLoader from "../../../../components/SpinnerLoader";
import StepSelectEndorsement from "../../../../components/Training/RequestSignature/StepSelectEndorsement";
import { getEndorsements, getEndorsementsFromApi, setEndorsements } from "../../../../store/slices/endorsement.slice";
import FlightService from "../../../../services/flight.service";
import { getRequestFormData, resetRequestFormData, setRequestFormData } from "../../../../store/slices/request-signature.slice";
import { confirmAlert } from "react-confirm-alert";
import RequestSignatureService from "../../../../services/request-signatures.service";
import useCustomToast from "../../../../hooks/useCustomToast";
import { Toaster } from "react-hot-toast";
import { useNavigate } from "react-router-dom";
import StepSelectRatingType from "../../../../components/Training/RequestSignature/StepSelectRatingType";

function CreateRequestSignature() {
  const [activeStepCount, setActiveStepCount] = useState(0);
  const [type, setType] = useState("");
  const [flights, setFlights] = useState([])

  const instructors = useAppSelector(getInstructors)
  const endorsements = useAppSelector(getEndorsements)
  const loading = useAppSelector(getUserApiStatus)
  const requestFormData = useAppSelector(getRequestFormData)


  const dispatch = useAppDispatch()
  const showMessage = useCustomToast()
  const navigate = useNavigate()

  const getFlights = async () => {
    const res: any = await FlightService.getAllFlights()
    if (res?.length) {
      if (res && res?.length) {
        setFlights(res)
      }
    }
  }
  useEffect(() => {
    dispatch(setEndorsements([]))
    dispatch(setStudentsList([]))
    dispatch(setInstructorsList([]))
  }, [])
  
  useEffect(() => {
    getFlights()
    dispatch(getInstructorsFromApi({ page: 1, per_page: 1000, query: '' }))
    dispatch(setStatusForStudentInstructor(API_STATUS.LOADING))
    dispatch(getEndorsementsFromApi({ page: 1, per_page: 1000, query: '' }))
    dispatch(setStatusForStudentInstructor(API_STATUS.SUCCEEDED))
  }, [dispatch])

  const handleSignatureType = (e: any) => {
    const value = e.target.value
    if (value === "0" && !flights?.length) {
      dispatch(setRequestFormData({ type: "", endorsementId: "", flightId: [] }))
      return showMessage("You have no flights to submit for signature", "error")
    }
    if (value === "1" && !endorsements?.length) {
      dispatch(setRequestFormData({ type: "", endorsementId: "", flightId: [] }))
      return showMessage("You have no endorsement to submit for signature", "error")
    }
    dispatch(setRequestFormData({ type: e.target.value, endorsementId: "", flightId: [] }))
  }

  const handleStepNext = (e: any) => {
    e.preventDefault();
    if (activeStepCount === 3) {
      confirmAlert({
        title: 'Confirm',
        message: `Are you sure you want to submit this request?`,
        buttons: [
          {
            label: 'Yes',
            onClick: async () => {
              dispatch(setStatusForStudentInstructor(API_STATUS.LOADING))
              const body = { ...requestFormData, requestType: requestFormData?.type === "0" ? REQUEST_TYPES.FLIGHT : requestFormData?.type === "1" ? REQUEST_TYPES.ENDORSEMENT : REQUEST_TYPES.RATING }
              delete body.type
              const res: any = await RequestSignatureService.create(body)
              if (res?.status === 201) {
                showMessage(res?.message || "Request Submitted Successfully!", "success")
                setTimeout(() => {
                  dispatch(resetRequestFormData(null))
                  navigate("/training/request-signatures")
                }, 2000)
              }
              dispatch(setStatusForStudentInstructor(API_STATUS.IDEAL))
            },
          },
          {
            label: 'No',
            onClick: () => { },
          },
        ],
      })
    } else {
      setActiveStepCount((prevActiveStep) => prevActiveStep + 1);
    }
  };

  const handleStepBack = (e: any) => {
    e.preventDefault();
    if (activeStepCount < 0) return;
    setActiveStepCount((prevActiveStep) => prevActiveStep - 1);
  };

  return (
    <LayoutProvider>
      <Toaster />
      {loading === API_STATUS.LOADING && <SpinnerLoader />}
      <div className="create_request_signature">
        <h2 className="heading2 ">Request Signatures</h2>
        <div className="wrapper">
          {activeStepCount <= 3 && (
            <h3 className="heading3 mb-3">Send Signature Request</h3>
          )}

          <form>
            {activeStepCount <= 3 && (
              <ul className="stepper">
                <li
                  className={`step ${activeStepCount === 0 ? "completed" : ""}`}
                >
                  01
                </li>
                <li
                  className={`step ${activeStepCount === 1 ? "completed" : ""}`}
                >
                  02
                </li>
                <li
                  className={`step ${activeStepCount === 2 ? "completed" : ""}`}
                >
                  03
                </li>
                <li
                  className={`step ${activeStepCount === 3 ? "completed" : ""}`}
                >
                  04
                </li>
              </ul>
            )}

            <div className="stepper__content">
              {activeStepCount === 0 && <StepZero handleSignatureType={handleSignatureType} type={type} />}
              {activeStepCount === 1 && requestFormData.type === "0" ? <StepSelectFlight flights={flights} /> : null}
              {activeStepCount === 1 && requestFormData.type === "1" ? <StepSelectEndorsement endorsements={endorsements} /> : null}
              {activeStepCount === 1 && requestFormData.type === "2" ? <StepSelectRatingType /> : null}
              {activeStepCount === 2 && <StepTwo instructors={instructors} />}
              {activeStepCount === 3 && <StepThree flights={flights} />}
            </div>

            {activeStepCount <= 3 && (
              <div className="d-flex justify-content-end step_counter_btn mt-3">
                {activeStepCount > 0 && (
                  <button
                    className="button me-2"
                    onClick={handleStepBack}
                    disabled={activeStepCount === 0}
                  >
                    Prev
                  </button>
                )}
                {activeStepCount < 3 ? (
                  <button className="button me-2" onClick={handleStepNext} disabled={requestFormData?.type === "" || activeStepCount === 2 && !requestFormData?.instructorId}>
                    Next
                  </button>
                ) : (
                  <button className="button me-2" onClick={handleStepNext}>
                    Submit
                  </button>
                )}
              </div>
            )}


          </form>
        </div>
      </div>
    </LayoutProvider>
  );
}

export default CreateRequestSignature;
